import { render, staticRenderFns } from "./SearchSite.vue?vue&type=template&id=a8f2e91c&"
import script from "./SearchSite.vue?vue&type=script&lang=js&"
export * from "./SearchSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f2e91c')) {
      api.createRecord('a8f2e91c', component.options)
    } else {
      api.reload('a8f2e91c', component.options)
    }
    module.hot.accept("./SearchSite.vue?vue&type=template&id=a8f2e91c&", function () {
      api.rerender('a8f2e91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SearchSite/components/SearchSite.vue"
export default component.exports